import { render, staticRenderFns } from "./subdomain.vue?vue&type=template&id=73882d0a&scoped=true"
import script from "./subdomain.vue?vue&type=script&lang=js"
export * from "./subdomain.vue?vue&type=script&lang=js"
import style0 from "./subdomain.vue?vue&type=style&index=0&id=73882d0a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73882d0a",
  null
  
)

export default component.exports